import styled from "styled-components"

const SubnavContainer_s = styled.div`
  background: #1163BF;
  font-family: "Roboto", sans-serif;
  position: fixed;
  height: 40px;
  top: 50px;
  width: 100%;
  z-index: 5;
`

const Section_s = styled.div`
  position: absolute;
  color: white;
  top: 11px;
  left: 15px;
`

const Tabs_s = styled.ul`
  position: absolute;
  display: flex;
  flex-direction: row;
  list-style-type: none;
  top: 8px;
  right: 80px;
  li {
    margin-right: 18px;
    a {
      color: white;
      font-size: 14px;
      padding-bottom: 2px;
      &.selected {
        border-bottom: 4px solid #15C7FF;
      }
    }
  }
`

export { SubnavContainer_s, Section_s, Tabs_s }